import { connectedStore } from '../../store';
import selectors from '../selectors';

const getAssetsUrl = () => {
  const store = connectedStore.get();
  const state = store.getState();

  return selectors.getAssetsUrl(state);
};

export default getAssetsUrl;
